import type { Selection } from "../types";

export type BlockMultiSelection = {
  selectedBlockIds: string[];
  primaryBlockId: string | null;
  anchorBlockId: string | null;
};

export function emptyBlockMultiSelection(): BlockMultiSelection {
  return {
    selectedBlockIds: [],
    primaryBlockId: null,
    anchorBlockId: null,
  };
}

export function blockMultiSelectionFromBlockId(
  blockId: string,
): BlockMultiSelection {
  return {
    selectedBlockIds: [blockId],
    primaryBlockId: blockId,
    anchorBlockId: blockId,
  };
}

export function deriveBlockMultiSelectionFromSelection(
  selection: Selection,
): BlockMultiSelection {
  if (selection.kind === "block" || selection.kind === "buttonRowSlot") {
    return blockMultiSelectionFromBlockId(selection.blockId);
  }

  return emptyBlockMultiSelection();
}

export function getPrimaryBlockId(
  blockSelection: Pick<BlockMultiSelection, "primaryBlockId" | "selectedBlockIds">,
): string | null {
  if (
    blockSelection.primaryBlockId !== null &&
    blockSelection.selectedBlockIds.includes(blockSelection.primaryBlockId)
  ) {
    return blockSelection.primaryBlockId;
  }

  return blockSelection.selectedBlockIds[0] ?? null;
}
